import { QueryClient } from '@tanstack/react-query';

const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  const status =
    typeof error === 'object' && error !== null && 'status' in error
      ? (error as { status?: unknown }).status
      : undefined;

  if (status === 429) {
    return false;
  }

  return failureCount < 2;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'online',
      staleTime: 0, // Always consider data stale - no caching
      gcTime: 0, // Don't keep unused data in cache
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
    mutations: {
      networkMode: 'online',
      retry: 2,
    },
  },
});

// Mutation defaults for consistent optimistic updates
queryClient.setMutationDefaults(['entities', 'create'], {
  mutationFn: async (_variables: unknown) => {
    throw new Error('Mutation function must be provided');
  },
});

queryClient.setMutationDefaults(['entities', 'update'], {
  mutationFn: async (_variables: unknown) => {
    throw new Error('Mutation function must be provided');
  },
});

queryClient.setMutationDefaults(['entities', 'delete'], {
  mutationFn: async (_variables: unknown) => {
    throw new Error('Mutation function must be provided');
  },
});
